export default {"src":"/_next/static/media/success.565a594b.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};